<template>
  <div class="flex flex-row bg-white flex-no-shrink flex-no-grow overflow-y-hidden" v-bind:style="chatType === 'online' ? 'height: calc(100vh - 3rem);' : 'width: calc(100% - 16rem); height: calc(100vh - 3rem);'">
    <template>
      <div class="flex flex-col bg-white w-12 flex-no-show flex-no-shrink border-solid border-r border-grey-lightest">
        <div v-if="showToggleButton" class="w-12 h-12 border-solid border-b border-grey-lightest bg-grey-darker flex flex-row justify-center flex-no-shrink" @click="togglePane">
          <img title="Hide Details" v-if="showRightPane" class="h-6 w-6 self-center" src="../assets/close_bar.png">
          <img title="Show Details" v-if="!showRightPane" class="h-6 w-6 self-center" src="../assets/open_bar.png">
        </div>
        <tab-menu v-bind:selectedTab="selectedTab" @tabChange="tabChange"/>
      </div> 
      <div v-if="showRightPane" class="flex flex-col bg-grey-extralight flex-no-show" v-bind:class="chatType == 'online' ? 'flex-no-shrink' : 'w-full'" v-bind:style="chatType === 'online' ? 'width: calc(674px - 12rem); padding-bottom: 50px;' : 'padding-bottom: 50px;'">
        <component :is="selectedTab" v-bind="currentProps"></component>
      </div>
    </template> 
  </div>
</template>

<script>
import TabMenu from '@/components/TabMenu'
import HealthCoach from '@/components/Customer/HealthCoachProgram'
import PatientHistory from '@/components/Customer/PatientMedicalHistory'
import Drugs from '@/components/Customer/Drugs'
import Forms from '@/components/Customer/Forms'
import HealthProfile from '@/components/Customer/HealthProfile'
import HealthScore from '@/components/Customer/HealthScore'
import OrderLabs from '@/components/Customer/OrderLabs'
import CustomerPastConsults from '@/components/Customer/CustomerPastConsults'
import PatientDocuments from '@/components/Customer/PatientDocs'
import ConsultationSummary from '@/components/Customer/ConsultationSummary'
import Notification from '@/components/Customer/CustomerNotification'
export default {
  components: {
    TabMenu,
    HealthCoach,
    PatientHistory,
    Drugs,
    Forms,
    HealthProfile,
    HealthScore,
    OrderLabs,
    CustomerPastConsults,
    PatientDocuments,
    ConsultationSummary,
    Notification
  },
  props: ['selectedTab', 'showRightPane', 'showToggleButton', 'chatType'],
  data () {
    return {
    }
  },
  computed: {
    url: function () {
      return '../assets/close_bar.png'
    },
    currentProps: function () {
      return { chatType: this.chatType }
    }
  },
  methods: {
    tabChange: function (tab) {
      this.$emit('tabChange', tab)
    },
    togglePane: function () {
      this.$emit('toggleRightPane', !this.showRightPane)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RightPane.vue